import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  // Carousel,
  Col,
  // ConfigProvider,
  Form,
  Input,
  message,
  Row,
  Select,
} from "antd";
import PageContainer from "../../../components/PageContainer";
// import Logo from "../../../images/logo.svg";
import { useParams } from "react-router-dom";
import { buyPackageService, getPackagesService } from "./payment.api";
import {
  ApiStatus,
  ContractsAndJudicialDocumentsTypes,
  DiscountType,
  RootCategoriesTypes,
} from "../../../constant/Types";
import {
  setValidationUserLogService,
  getWalletBalanceService,
  handlePaymentService,
  getBankGatewayService,
} from "../../transactions/transactions.api";
import {
  checkValue,
  convertNumToFa,
  convertSecondToTime,
} from "../../../constant/helper";
import BottomSheet from "../../../components/BottomSheet";
import { LeftOutlined, DeleteFilled, CheckOutlined } from "@ant-design/icons";

import "./Payment.scss";
import { getSessionDetailService } from "../../archive/archive.api";

function Payment({ title }) {
  const { sessionId, rootType } = useParams();

  const chatLink = `/consultation/${rootType}/${sessionId}`;
  const [paymentPopup, setPaymentPopup] = useState(false);

  // const history = useHistory();
  const discountInputRef = useRef();
  const [apiData, setApiData] = useState([]);
  const [apiStatus, setApiStatus] = useState(ApiStatus.loading);
  const [activePlan, setActivePlan] = useState({});
  const [balance, setBalance] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [loadingValidateDiscount, setLoadingValidateDiscount] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);
  const [discountDetail, setDiscountDetail] = useState({
    discountCode: "",
    discountPrice: 0,
    finalPrice: 0,
    discountType: { value: 0, type: DiscountType.PERCENT },
  });
  const [bankGateways, setBankGateways] = useState([]);
  const [PayableValue, setpayableValue] = useState(0);
  const [sessionDetail, setSessionDetail] = useState();
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    fetchBankGatewayList();
    // eslint-disable-next-line
  }, []);
  function fetchBankGatewayList() {
    getBankGatewayService()
      .then((resp) => {
        const { content } = resp.data;
        setBankGateways(content);

        if (content.length > 0) {
          setPaymentForm({
            ...paymentForm,
            bankGatewayId: content[0]["id"],
          });
        }
      })
      .catch((error) => {
        message.error("دریافت لیست بانک ها با خطا مواجه شد!");
      });
  }
  const [paymentForm, setPaymentForm] = useState({
    amount: "",
    clientCallbackUrl: window.location.href,
    bankGatewayId: "",
    description: "خرید بسته",
    walletTransactionType: "DEPOSIT",
  });
  // eslint-disable-next-line
  const carouselSettings = {
    infinite: false,
    dots: true,
    centerMode: true,
    //centerPadding: "10px",
    slidesToShow: 1,
    variableWidth: true,
    adaptiveHeight: true,
    initialSlide: 1,
    // rtl: true,
    appendDots: (dots) => (
      <div style={{ bottom: "-2rem" }}>
        <ul style={{ margin: "0", padding: "0", color: "#E39F0E" }}>{dots}</ul>
      </div>
    ),
    afterChange: function (current) {
      setActivePlan(apiData[current]);
    },
  };

  useEffect(() => {
    getPackages();
    getBalance();
    getSessionDetail();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (showDiscountBox) {
      handleValidateDiscountCode();
    }
    // eslint-disable-next-line
  }, [activePlan]);

  function getBalance() {
    setApiStatus(ApiStatus.loading);
    getWalletBalanceService()
      .then((resp) => {
        setBalance(resp.data.balance);
        setApiStatus(ApiStatus.done);
      })
      .catch((error) => {
        setApiStatus(ApiStatus.error);
      });
  }

  function getPackages() {
    getPackagesService(sessionId)
      .then((resp) => {
        setApiData(resp.data);
        if (resp.data.length > 0) {
          setActivePlan(resp.data[0]);
        }
        setApiStatus(ApiStatus.done);
      })
      .catch((error) => {
        setApiStatus(ApiStatus.error);
      });
  }

  function getSessionDetail() {
    getSessionDetailService(sessionId)
      .then((res) => {
        setSessionDetail(res.data);
      })
      .catch((error) => {
        setApiStatus(ApiStatus.error);
      });
  }

  function payUp() {
    // if (
    //   !(
    //     discountDetail.finalPrice > balance && discountDetail.finalPrice !== 0
    //   ) &&
    //   !(activePlan.price > balance)
    // ) {
    // }
    let payableValue = Number(activePlan.price);
    if (showDiscountBox && !isNaN(discountDetail.finalPrice)) {
      payableValue = discountDetail.finalPrice;
    }

    if (Number(balance) < payableValue) {
      // go to transactions & bank
      // sessionStorage.setItem(
      //   sessionId,
      //   JSON.stringify({
      //     price: payableValue - Number(balance),
      //     pathname: history.location.pathname,
      //   })
      // );
      // history.push(`/transactions/${sessionId}`);
      // directPurchase({ payableValue });
      setpayableValue(payableValue);
      setPaymentPopup(true);
    } else {
      // wallet
      buyPackage();
    }
  }

  const directPurchase = () => {
    if (PayableValue - balance > 1999) {
      handlePaymentService({
        amount: PayableValue - balance,
        bankGatewayId: paymentForm.bankGatewayId,
        clientCallbackUrl: window.location.href.replace("/payment", ""),
        ...(discountDetail.discountCode
          ? { coupon: discountDetail.discountCode }
          : {}),
        itemsCoefficient: activePlan.itemsCoefficient,
        relatedId: sessionId,
        walletTransactionType: "DEPOSIT_FOR_DIRECT_BUY",
        description: paymentForm.description,
      })
        .then((response) => {
          window.location.replace(response.data.paymentLink);
        })
        .catch((error) => {
          message.error("مشکل در پرداخت");
        });
    } else {
      message.error(
        "پرداخت مبلغ کمتر از 2000 تومان از درگاه بانکی ممکن نیست . برای ادامه ابتدا از بخش کیف پول موجودی خود را افزایش دهید"
      );
    }
  };

  function buyPackage() {
    let params = {
      itemsCoefficient: activePlan.itemsCoefficient,
      sessionId,
    };

    if (showDiscountBox && discountDetail.discountCode)
      params = { ...params, coupon: discountDetail.discountCode };

    buyPackageService(params)
      .then((resp) => {
        message.success("پرداخت با موفقیت انجام شد");
        window.location.href = window.location.href.replace("/payment", "");
        // history.push(chat);
      })
      .catch((e) => {
        message.error("پرداخت با خطا مواجه شد");
      });
  }

  const handleValidateDiscountCode = () => {
    if (!checkValue(discountCode)) {
      message.error("کد تخفیف را وارد نمایید");
    } else {
      discountInputRef.current && discountInputRef.current.blur();
      setLoadingValidateDiscount(true);
      setShowDiscountBox(false);

      setValidationUserLogService(discountCode, activePlan.price)
        .then((res) => {
          if (res.hasOwnProperty("data")) {
            setDiscountDetail({
              ...discountDetail,
              discountCode: discountCode,
              finalPrice: res.data.paymentAmount,
              discountPrice: res.data.discountAmount,
              discountType: res.data.type,
            });

            setShowDiscountBox(true);
          } else {
            message.error("کد تخفیف نا معتبر است");
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            // message.error("کد تخفیف نا معتبر است");
          } else if (
            err.response.status === 400 &&
            err.response.data.errors[0].message ===
              "Discount code has been expired."
          ) {
            message.error("کد تخفیف منقضی شده است ");
          } else {
            message.error("خطا در دریافت اطلاعات");
          }
        })
        .finally(() => setLoadingValidateDiscount(false));
    }
  };

  function handleChangePaymentForm(value = "", prop = "price") {
    setPaymentForm({ ...paymentForm, [prop]: value });
  }

  return (
    <PageContainer
      classNames="payment"
      headerProps={{
        link: chatLink,
        content: "پرداخت",
        className: "",
      }}
      loading={
        apiStatus === ApiStatus.loading ||
        loadingValidateDiscount ||
        !sessionDetail
      }
    >
      <div className="title">
        {title
          ? title
          : rootType === "advocacy_acceptation"
          ? "جهت رزرو جلسه حضوری لطفا نسبت به پرداخت اقدام نمایید"
          : "جهت ارجاع به وکیل نسبت به پرداخت اقدام نمایید"}
      </div>
      {sessionDetail && (
        <div className="details">
          {!sessionDetail.category.other &&
          sessionDetail.category.timeBased &&
          rootType !== "advocacy_acceptation" ? (
            <>
              <div className="item">
                <div className="title">نوع خدمت:</div>
                <div className="text">
                  <strong>
                    {ContractsAndJudicialDocumentsTypes[rootType]?.value ||
                      RootCategoriesTypes[rootType]?.value}
                    {" (" + sessionDetail.category.name + ")"}
                  </strong>
                </div>
              </div>
              <div className="item">
                <div className="title">مدت زمان:</div>
                <div className="text">
                  <strong>
                    {convertNumToFa(
                      rootType === "call"
                        ? sessionDetail.category.sessionTimeInMinutes.toLocaleString("fa")
                        : sessionDetail.category.expiresInHours.toLocaleString("fa")
                    )}
                  </strong>
                  {rootType === "call" ? (
                    <small> دقیقه</small>
                  ) : (
                    <small> ساعت</small>
                  )}
                </div>
              </div>
              <div className="item">
                <div className="title">
                  {rootType === "call"
                    ? "پس از پرداخت ارتباط شما با وکیل برقرار میگردد"
                    : "پس از انقضاء مدت ارتباط شما با وکیل پایان می پذیرد"}
                </div>
              </div>
            </>
          ) : rootType === "advocacy_acceptation" ? (
            <>
              <div className="item">
                <div className="title">نوع خدمت:</div>
                <div className="text">
                  <strong>{sessionDetail.category.name}</strong>
                </div>
              </div>
              <div className="item">
                <div className="title">زمان جلسه:</div>
                <div className="text">
                  <strong>با هماهنگی</strong>
                </div>
              </div>
              <div className="item">
                <div className="title">مدت جلسه:</div>
                <div className="text">
                  <strong>{convertNumToFa(1)}</strong>
                  <small> ساعت</small>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="item">
                <div className="title">زمان مجاز ارسال وویس:</div>
                <div className="text">
                  <strong>
                    {convertNumToFa(
                      (activePlan.totalRemainingTimeInSeconds !== undefined
                        ? convertSecondToTime(
                            activePlan.totalRemainingTimeInSeconds
                          )
                        : "0"
                      ).toLocaleString("fa")
                    )}
                  </strong>
                  <small> دقیقه</small>
                </div>
              </div>
              <div className="item">
                <div className="title">معادل تعداد کاراکتر مجاز تایپ:</div>
                <div className="text">
                  <strong>
                    {convertNumToFa(
                      (activePlan.remainingCharacters || 0).toLocaleString("fa")
                    )}
                  </strong>
                  <small> کاراکتر</small>
                </div>
              </div>
              <div className="item">
                <div className="title">معادل تعداد صفحه مجاز آپلود:</div>
                <div className="text">
                  <strong>
                    {convertNumToFa(
                      (activePlan.remainingDocumentPages || 0).toLocaleString(
                        "fa"
                      )
                    )}
                  </strong>
                  <small> صفحه</small>
                </div>
              </div>
              <div className="item">
                <div className="title">تعداد صفحه رایگان آپلود:</div>
                <div className="text">
                  <strong>
                    {convertNumToFa(
                      (activePlan.freeDocumentPages || 0).toLocaleString("fa")
                    )}
                  </strong>
                  <small> صفحه</small>
                </div>
              </div>
              <div className="item">
                <div className="title">مهلت استفاده:</div>
                <div className="text">
                  <strong>
                    {activePlan?.expiresInHours > 48
                      ? activePlan?.expiresInHours / 24
                      : activePlan?.expiresInHours}
                  </strong>
                  {activePlan?.expiresInHours > 48 ? (
                    <small> روز</small>
                  ) : (
                    <small> ساعت</small>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {apiData &&
        apiData.length > 1 &&
        (apiData[1].itemsCoefficient !== 1 ||
          apiData[1].price !== apiData[0].price ||
          (apiData.length > 2 &&
            (apiData[2].itemsCoefficient !== 1 ||
              apiData[2].price !== apiData[0].price))) && (
          <div className="special-offers">
            <div className="title" onClick={() => setExpanded((pre) => !pre)}>
              <span>پیشنهادات ویژه</span>
              <LeftOutlined className={`icon${expanded ? " expanded" : ""}`} />
            </div>
            <div className={`list${expanded ? " expanded" : ""}`}>
              {apiData
                .slice(1)
                .filter(
                  (v) =>
                    v.itemsCoefficient !== 1 || v.price !== apiData[0].price
                )
                .map((item, index) => (
                  <div
                    onClick={() =>
                      activePlan === item
                        ? setActivePlan(apiData[0])
                        : setActivePlan(item)
                    }
                    className={`item${activePlan === item ? " active" : ""}`}
                    key={index}
                  >
                    {/* <img src={DiscountLogo} alt="offer" /> */}
                    <div className="details">
                      <div>
                        {convertNumToFa(item.itemsCoefficient)}
                        {/* &times; */} برابر بیشتر
                      </div>
                      <div>
                        {convertNumToFa(
                          Math.floor(
                            ((apiData[0].price * item.itemsCoefficient -
                              item.price) /
                              (apiData[0].price * item.itemsCoefficient)) *
                              100
                          )
                        )}
                        ٪ تخفیف
                      </div>
                    </div>
                    <div className="actions">
                      {activePlan !== item ? (
                        <Button className="select-btn">انتخاب</Button>
                      ) : (
                        <div className="delete-btn">
                          <span>
                            <CheckOutlined />
                            انتخاب شده
                          </span>
                          <DeleteFilled />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

      <Row className="mt-4">
        <Col span={24}>
          <Input
            ref={discountInputRef}
            className="discount-code"
            placeholder="کد تخفیف"
            name="discountCode"
            disabled={loadingValidateDiscount}
            value={discountCode}
            onChange={(event) => setDiscountCode(event.target.value)}
            // allowClear
            suffix={
              <Button
                className="discount-button"
                disabled={loadingValidateDiscount}
                onClick={handleValidateDiscountCode}
              >
                اعمال
              </Button>
            }
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col span={24}>
          <div className="total-price">
            <div className="title">کیف پول:</div>
            <div className="text">
              <strong>{convertNumToFa(balance.toLocaleString("fa"))}</strong>
              <small> ریال</small>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col span={24}>
          <div className="total-price">
            <div className="title">هزینه قابل پرداخت:</div>
            <div className="text">
              {apiData &&
                apiData.length > 0 &&
                activePlan &&
                activePlan !== apiData[0] && (
                  <div className="discount">
                    {convertNumToFa(
                      Math.floor(
                        activePlan.itemsCoefficient * apiData[0].price
                      ).toLocaleString("fa")
                    )}
                  </div>
                )}
              <strong>
                {activePlan && activePlan.price
                  ? convertNumToFa(activePlan.price.toLocaleString("fa"))
                  : "-"}
              </strong>
              <small> ریال</small>
            </div>
          </div>
        </Col>
      </Row>
      {showDiscountBox && (
        <Row>
          <Col span={24}>
            <div className="discount-box">
              <div className="discount-percent">
                <span>
                  {convertNumToFa(
                    discountDetail.discountType?.value.toLocaleString("fa")
                  )}
                  {discountDetail.discountType.type === DiscountType.PERCENT
                    ? "%"
                    : " ریال"}
                </span>
              </div>
              <div className="discount-details">
                <div className="discount-rows">
                  <div className="discount-title">
                    {discountDetail.discountCode}
                  </div>
                  <div
                    className="close-btn"
                    onClick={(event) => {
                      message.success("کد تخفیف لغو شد");
                      setDiscountCode("");
                      setShowDiscountBox(false);
                      setDiscountDetail({
                        discountCode: "",
                        discountPrice: 0,
                        finalPrice: 0,
                        discountType: { value: 0, type: DiscountType.PERCENT },
                      });
                    }}
                  >
                    <span className="icon-cancel" />
                  </div>
                </div>
                <div className="discount-rows">
                  <div className="title">تخفیف:</div>
                  <div className="text discount-amount">
                    <strong>
                      {convertNumToFa(
                        discountDetail.discountPrice.toLocaleString("fa")
                      )}
                    </strong>
                    <small>ریال</small>
                  </div>
                </div>
                <div className="discount-rows">
                  <div className="title">هزینه کل:</div>
                  <div className="text">
                    <strong>
                      {activePlan && activePlan.price
                        ? convertNumToFa(activePlan.price.toLocaleString("fa"))
                        : "-"}
                    </strong>
                    <small>ریال</small>
                  </div>
                </div>
                <div className="discount-rows">
                  <div className="title">هزینه قابل پرداخت:</div>
                  <div className="text">
                    <strong className="final-price">
                      {convertNumToFa(
                        discountDetail.finalPrice.toLocaleString("fa")
                      )}
                    </strong>
                    <small>ریال</small>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
      <div className="submit-btn center-text mt-4 pt-2 pb-15">
        <Form.Item>
          <Button
            type="primary"
            shape="round"
            htmlType="submit"
            onClick={payUp}
          >
            {discountDetail.discountCode
              ? discountDetail.finalPrice > balance &&
                discountDetail.finalPrice !== 0
                ? `پرداخت`
                : `پرداخت با کیف پول`
              : activePlan.price > balance
              ? `پرداخت`
              : `پرداخت با کیف پول`}
          </Button>
        </Form.Item>
      </div>

      <BottomSheet
        setClose={() => setPaymentPopup(false)}
        isOpen={paymentPopup}
        classNames={"payment-popup-transactions"}
        viewerClassName={"payment-popup-transactions-viewer right-text"}
      >
        <Row justify="center">
          <Col span={18}>
            <h3> افزایش اعتبار حساب کاربری (ریال) </h3>
            <div className="center-text">
              <div className={"mt-3"}>
                <Select
                  size="large"
                  value={paymentForm.bankGatewayId}
                  onChange={(value) => {
                    handleChangePaymentForm(value, "bankGatewayId");
                  }}
                >
                  {bankGateways &&
                    bankGateways.map((i) => (
                      <Select.Option value={i.id} key={i.id}>
                        {i.name ? i.name : i.type}
                      </Select.Option>
                    ))}
                </Select>
              </div>
              <div className={"submit-btn mt-3"}>
                <Button
                  type="primary"
                  onClick={directPurchase}
                  // loading={loading}
                  // disabled={paymentLoading}
                >
                  پرداخت
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </BottomSheet>
    </PageContainer>
  );
}

export default Payment;
